import React from 'react';
import { ReactComponent as FigHourglass03Component } from './FigHourglass03.svg';

const FigHourglass03 = (props) => <FigHourglass03Component {...props} />;

export default FigHourglass03;
